import { render, staticRenderFns } from "./TrackingEventsSettings.vue?vue&type=template&id=736b811a&lang=pug"
import script from "./TrackingEventsSettings.vue?vue&type=script&lang=js"
export * from "./TrackingEventsSettings.vue?vue&type=script&lang=js"
import style0 from "./TrackingEventsSettings.vue?vue&type=style&index=0&id=736b811a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports